import Fab from '@material-ui/core/Fab/Fab';
import AddIcon from '@material-ui/icons/Add';
import React from 'react';
import PropTypes from 'prop-types';
import { CONFIRM_DIALOG, ROLE_DIALOG } from '../../../../redux/constants/dialogs';
import getNoDataCellComponent from '../../../Common/NoDataCellComponent';
import styles from './styles';
import LockOutlineIcon from '@material-ui/icons/LockOutlined';
import Grid from '../../../Common/Grid/index';

const COLUMNS = [
  { name: 'name', title: 'Role' },
  { name: 'action', title: ' ' },
];

const COLUMN_EXTENSIONS = [
  { columnName: 'action', width: 150 },
];

const getCellComponent = ({ row, column, value }) => {
  switch (column.name) {
    default :
      return value;
  }
};

class RolesGrid extends React.Component {

  handleAdd = () => {
    this.handleEdit({});
  };

  handleEdit = (role) => {
    this.props.showDialog(ROLE_DIALOG, { role });
  };

  handleRemove = (role) => {
    return new Promise((resolve, reject) => {
      this.props.showDialog(CONFIRM_DIALOG, {
        title: 'Are you sure you wish to remove this role?',
        onConfirm: () => {
          this.props.onRemove(role).then(() => resolve());
        },
        onReject: reject,
        confirmColor: 'secondary',
      });
    });
  };

  render() {
    const { data, fetch } = this.props;

    const buttons = [<Fab
      key="add"
      style={styles.addItem}
      onClick={this.handleAdd}
      color="secondary"
    >
      <AddIcon/>
    </Fab>];

    return (<Grid
      buttons={buttons}
      columns={COLUMNS}
      columnExtensions={COLUMN_EXTENSIONS}
      cellComponent={getCellComponent}
      data={data}
      fetch={fetch}
      onEdit={this.handleEdit}
      onRemove={this.handleRemove}
      noDataCellComponent={getNoDataCellComponent(<LockOutlineIcon style={styles.noData}/>, 'roles')}
    />);
  }
}

RolesGrid.propTypes = {
  showDialog: PropTypes.func.isRequired,
};

export default RolesGrid;



// WEBPACK FOOTER //
// ./src/components/Admin/Roles/RolesGrid/index.js